module.exports = __webpack_public_path__ + "img/header-weddingRingsStarrySky@2x.e4a7c73.jpg";